/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import Modal from 'react-modal';
import { Card } from 'react-bootstrap';
import { IVideoModalProps, VideoModal } from './videoViewer';
import * as S from './styles';

export type IVideoViewerModalProps = {
  showModal: boolean;
  closeModal?(): void;
  [key: string]: any;
} & IVideoModalProps;

export const VideoViewerModal = ({
  showModal,
  closeModal,
  ...rest
}: IVideoViewerModalProps) => {
  return (
    <Modal
      isOpen={showModal}
      style={S.ModalStyle}
      onRequestClose={closeModal}
      appElement={
        typeof global.window !== 'undefined'
          ? global.window.document.body
          : undefined
      }
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
        }}
      >
        <Card style={{ height: 'fit-content', display: 'flex' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
            }}
          >
            {' '}
            <VideoModal {...rest} closeModal={closeModal} />
          </div>
        </Card>
      </div>
    </Modal>
  );
};

VideoViewerModal.defaultProps = {
  showModal: false,
  closeModal: true,
};
